var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUrySm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 2H2V3.34132H14V2Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 3.34131H2V4.68263H14V3.34131Z",
    fill: "#004CB9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 4.68265H2V6.02396H14V4.68265Z",
    fill: "#F0F0F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 6.02396H2V7.36527H14V6.02396Z",
    fill: "#004CB9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 7.36526H2V8.70658H14V7.36526Z",
    fill: "#F0F0F0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8.70657H2V10.0479H14V8.70657Z",
    fill: "#004CB9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14 11.3892H2V12.7305H14V11.3892Z",
    fill: "#004CB9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14 10.0479H2V11.3892H14V10.0479Z",
    fill: "#F0F0F0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14 12.6587H2V14H14V12.6587Z",
    fill: "#F0F0F0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60938 2.09375H2V8.70312H8.60938V2.09375Z",
    fill: "#F0F0F0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.10019 5.39425L6.36739 5.73894L6.7576 6.44863L5.9619 6.29643L5.86107 7.10021L5.30687 6.50903L4.75262 7.10021L4.65182 6.29643L3.85611 6.44858L4.2463 5.73892L3.51355 5.39425L4.24632 5.0496L3.85611 4.33991L4.65179 4.49211L4.75264 3.68832L5.30687 4.27951L5.8611 3.68832L5.9619 4.49211L6.75763 4.33991L6.36742 5.04962L7.10019 5.39425Z",
    fill: "#FFDA44"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrySm);
export default __webpack_public_path__ + "static/media/URY-SM.9a0d631fb76dfd24dd10e9546f100cb9.svg";
export { ForwardRef as ReactComponent };